// extracted by mini-css-extract-plugin
export default {"card":"d0-z"};